import React, { useEffect, useState, useContext } from "react";
import { CurrentUserContext } from "../../../context/CurrentUserContext";
import { Link, useParams } from 'react-router-dom';
import { slugToText } from "../../../utils/slugify";
import './HtmlMyNotes.css';
import DeleteNotePopup from "./DeleteNotePopup";
import { useTranslation } from "../../../utils/hooks/translateHook";
import { readerDocsData } from "../../Content/readerData.js";
import { slugify } from "../../../utils/slugify";
import downloadIcon from "../../../images/icons/download.svg";
import viewIcon from "../../../images/icons/viewIcon.svg";
import deleteIcon from "../../../images/icons/DeleteIcon.svg";
import nots from "../../../images/Notes_1440.png"

export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL

console.log("Fetching notes from:", `${API_URL}/notes/`);

const HtmlMyNotes = () => {
  const { currentUser, notesUpdated, setNotesUpdated } = useContext(CurrentUserContext);
  const { courseSlug} = useParams();
  const [ notes, setNotes ] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);
  const [ noteToDelete, setNoteToDelete ] = useState(null);
  const [isDeletePopupOpen, setIsDeletePopupOpen ] = useState(false);
  const t = useTranslation();

  const fetchNotes = () => {
    fetch(`${API_URL}/notes/course/${courseSlug}?_=${Date.now()}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`}
    })
    .then(res => res.json())
    .then(data => {
      const sorted =data.sort((a,b) => {
      const parse = (slug) => {if (!slug) return [0, 0, 0];
      const nums = slug.split('-').map(n => Number(n));
      return nums.length >= 3 ? nums.slice(0, 3) : [0, 0, 0];
      };

      const [a1, a2, a3] = parse(a.videoSlug);
      const [b1, b2, b3] = parse(b.videoSlug);
      return a1 - b1 || a2 - b2 || a3 - b3
      });
      setNotes(sorted);
    });
  };
  

  useEffect(() => {
    if (!currentUser?._id) return;  
    fetchNotes();
  }, [currentUser, notesUpdated, courseSlug])

  const handleDeleteNote = (note) => {
    fetch(`${API_URL}/notes/${courseSlug}/${note.videoSlug}?_=${Date.now()}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`}
    })
    .then((res) => {
      if (!res.ok) throw new Error('Failed to delete');
      fetchNotes();
      setNotesUpdated(prev => prev + 1);
      setIsDeletePopupOpen(false);
    })
    .catch((err) => {
      alert('Error deleting note');
      console.error(err);
    });
  }

  const downloadNote = (slug, content) => {
    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(slug)}.text`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

const groupedNotes = notes.reduce((acc, note) => {
  const parts = note.videoSlug.split('-');
  const bookSlug = parts.slice(0, 4).join('-');
  const sectionSlug = parts.slice(4).join('-');
  if (!acc[bookSlug]) {
    acc[bookSlug] = {bookTitle: slugToText(bookSlug), notes: []};
  }
  acc[bookSlug].notes.push({...note, sectionSlug});
  return acc;
}, {});


  return (
    <div className="frameN">
      <h1>{t('notes')}</h1>
      <div className="lay">
        <div className="notes-layout">
          <div className="notes-list">
            {notes.length === 0 && <p>{t('noNotes')}</p>}
            <div className="notes-group">
              {Object.entries(groupedNotes).map(([bookKey, group]) => (
                <div key={bookKey} className="notes-group">
                  <div className="notes-group-title">
                    {group.bookTitle}
                  </div>
                  <ul>
                    {group.notes.map((note) => (
                      <li key={note._id} className="note-item-html">
                        <div className="note-header">
                        <Link to={`/course/${courseSlug}/docs/${note.videoSlug}`}
                            className="note-title"
                        >
                          {slugToText(note.sectionSlug)}
                        </Link>
                        <div className="note-actions">
                          <button onClick={() => downloadNote(note.videoSlug, note.content)}>
                            <div className="icon" style={{ "--icon": `url(${downloadIcon})`}} />
                          </button>
                          <button onClick={() =>setSelectedNote(selectedNote?._id === note._id ? null : note)}>
                            <div className="icon" style={{ "--icon": `url(${viewIcon})` }} />
                          </button>
                          <button onClick={() => {
                            setNoteToDelete(note);
                            setIsDeletePopupOpen(true);
                          }}>
                            <div className="icon" style={{ "--icon": `url(${deleteIcon})` }} />
                          </button>
                        </div>
                        </div>
                      </li>
                    ))}
                 </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="notes-preview">
            {!selectedNote ? (
              <img src={nots} className="notes-image" />
            ) : (
              <div className="note-content">
                {selectedNote.content}
              </div>
            )}
          </div>
      </div>

      <DeleteNotePopup
        isOpen={isDeletePopupOpen}
        onClose={() => setIsDeletePopupOpen(false)}
        onDelete={handleDeleteNote}
        note={noteToDelete}
      />
     </div>
   </div>
  );
};


export default HtmlMyNotes;